module.exports = __webpack_public_path__ + "img/reports.38879a24.svg";